define(['underscore','text!./templates/pa-edit-vehicle.html'],
    (_,templateStr)=> {
        return ['VinLookupService', 'VinLookupEnabled', '$q', '$filter','ModalService', '$timeout', 
            (VinLookupService, VinLookupEnabled, $q, $filter, ModalService, $timeout)=> {
                return {
                    restrict: 'A',
                    scope: {
                        vehicle: '=',
                        drivers: '=',
                        readonly: '=',
                        quoteId: '=',
                        availableYears: '='
                    },
                    template: templateStr,
                    //added $rootScope *Princy
                    controller: ['$scope','$rootScope',($scope,$rootScope)=> {
                      
                        let watchYear;
                        let watchMake;
                        let watchModel;
                        let watchCylinder;
                        let watchphysicalDamage ;
                        let watchStorageTye;
                        $scope.isFormSubmitted = false;
                        $scope.leaseOptions = [{ name: "Other"}];
                        $scope.leaseSelectedOption = $scope.leaseOptions[0];
                        $scope.financeOptions = [{ name: "Other"}];
                        $scope.financeSelectedOption = $scope.financeOptions[0];

                        $scope.showCost = false;

                        // addded isPrefilledVehicle Flag *Princy
                    //   console.log($rootScope)
                    if($scope.vehicle.isPrefilledVehicle.value== true){
                        $rootScope.isPrefilledVehicle = true;
                    }
                    // console.log($rootScope)
                    // end of statement-- isPrefilledDriver Flag *Princy

                        $scope.showCostDiv = () => {
                            $scope.vehicle.costNew.amount = undefined;
                            $scope.showCost = true;
                        };
                        if($scope.vehicle.isPrefilledVehicle.value){
                            if($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == 'auto' &&
                                ($scope.vehicle.comprehensiveSymbolCd.value == "" || $scope.vehicle.comprehensiveSymbolCd.value == " ")
                                && ($scope.vehicle.collisionSymbolCd.value == "" || $scope.vehicle.collisionSymbolCd.value == " ")
                                && ($scope.vehicle.twoDgVSRSymbol.value == "" || $scope.vehicle.twoDgVSRSymbol.value == " ")){
                                $scope.showCost = true;
                            } else {
                                $scope.showCost = false;
                            }
                            if($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == 'motorcycle_aaa' &&
                                ($scope.vehicle.costNew.amount.value == "" || $scope.vehicle.costNew.amount.value == " " || $scope.vehicle.costNew.amount.value == undefined)){
                                $scope.showCost = true;
                            } else {
                                $scope.showCost = false;
                            }
                        }
                        $scope.hasMotorcycleEndorsement = function(vehicle){
                            for (let endorse = 0; endorse < $scope.drivers.length; endorse++ ){
                                if( $scope.drivers[endorse].inMotorCycle==true && $scope.drivers[endorse].endorsementOnDriverLicense==true){
                                    vehicle.motorcycleEndorsement.value = true;
                                    return true;
                                }
                            }


                            return false;
                        };
                        
                        $scope.populateYears = () => {
                                var vinDetails = {
                                searchType: undefined
                                };
                            vinDetails.searchType = "AvailableYears"
                            
                            // Set additional request params required to call new vin service
                            $scope.setAdditionalRequestParamsAuto(vinDetails);
                            
                            /*$q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                                    (result) => {
                            var arr = JSON.parse("[" + result.jsonOutputString + "]");
                                    for (var i = 0; i < arr[0].length; i++)
                            {
                            $scope.years.push(parseInt(arr[0][i]));
                            }
                            
                            // When quote retrieved
                            if($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined){
                                $scope.populateMake();
                            }
                             
                            });*/
                            
                            $timeout(function(){
                                $scope.minYear = $scope.availableYears[0];
                                $scope.maxYear = $scope.availableYears[$scope.availableYears.length - 1];
                                // When quote retrieved

                                if($scope.vehicle.year.value!=undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN!=false*/) {
                                    if ($scope.vehicle.year && $scope.vehicle.year.value != undefined
                                                                                && $scope.vehicle.make.value != undefined
                                                                                && $scope.makesList.length == 0){
                                         $scope.populateMake();
                                     }

                                }else if($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/){
                                   if( $scope.vehicle.year && $scope.vehicle.year.value != undefined
                                         && $scope.vehicle.make.value != undefined ){
                                        $scope.populateHldiMake();
                                   }
                                }

                            }, 100);
                            
                            
                            
                        };
                        
                        // Check the vin is long vin
                        $scope.isLongVIN = function(){
                            
                            if($scope.vehicle.vin 
                                    && $scope.vehicle.vin.value 
                                        && $scope.vehicle.vin.value.length == 17){
                                return true; 
                            }
                            
                            return false;
                        };

                         function resetForm() {
                            $scope.years = [];
                            $scope.makes = [];
                            $scope.models = [];
                            $scope.shortVins=[];
                            $scope.series = [];
                            $scope.cylinders = []
                            $scope.makesList = [];
                            $scope.modelsList = [];
                            $scope.vinPatList = [];
                            //$scope.vinPatList = [];
                            $scope.cylinderList = [];
                            $scope.seriesList = [];
                            $scope.errorMsg = '';
                            $scope.showLoading = false;
                            //$scope.invalidVIN = null;
                            $scope.tmpVehicleType = undefined;
                            $scope.selectedIndex = 0;
                            //To display within last 60 days question
                                //For defect DE1703
                           // $scope.isPurchase = false
                            $scope.vehicleType= null ;
                            $scope.vinOld = undefined;
                            $scope.vinNew = undefined;
                            $scope.today = new Date();
                            $scope.today.setHours(0, 0, 0, 0);
                            $scope.motorcycleEndorsement = false;
                            const currentYear = new Date().getUTCFullYear();
                            
                            const OLDEST_CAR_YEAR = 1908;
                            
                            // Populate year list for short VIN for the retrieved quote
                            // Populate years
                            $timeout(function(){
                                $scope.populateYears();
                            }, 1000);     
                            
                            
                           //************** Resetting Values*************************************
                            if($scope.vehicle.paType!= undefined && $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code!=undefined){
                                $scope.vehicle.tmpPaType.value = $scope.vehicle.paType.value.code;
                            }
                            
                        
                            if($scope.vehicle.vin!= undefined && $scope.vehicle.vin.value != undefined ){
                                
                                $scope.readonly = true;
                                $scope.showLoading = false;
                                //$scope.invalidVIN = false;
                            }
                           
                             if ($scope.vehicle.primaryUse != undefined && $scope.vehicle.primaryUse.value != undefined && $scope.vehicle.primaryUse.value.code != undefined){
                                  
                                  //$scope.vehicle.tmpPrimeUse.value = "less10"
                                       if($scope.vehicle.primaryUse.value.code=="commuting") {
                                            if ($scope.vehicle.commutingMiles.value == 5)
                                            $scope.vehicle.tmpPrimeUse.value = "less10"
                                            if ($scope.vehicle.commutingMiles.value == 15)
                                            $scope.vehicle.tmpPrimeUse.value = "more10"
                                        }else if($scope.vehicle.primaryUse.value.code == "pleasure"){
                                            $scope.vehicle.tmpPrimeUse.value = "Personal";
                                        }else{
                                        $scope.vehicle.tmpPrimeUse.value = "Business"
                                        }
                                }
                            if($scope.vehicle.ownership != undefined){
                                if (  $scope.vehicle.ownership.value != undefined && $scope.vehicle.ownership.value.code != undefined){
                                     $scope.vehicle.tmpOwnership.value = $scope.vehicle.ownership.value.code
                                }else{
                                    $scope.vehicle.tmpOwnership.value = "Own"
                                }
                            }
                            //*************End Resetting************************************
                            //For testing purpose defaulting vehicle to car
                            if($scope.vehicle.paType!=undefined){
                                if($scope.vehicle.paType.value==undefined)
                                $scope.vehicle.paType.value = "auto"
                            }
                            watchYear = $scope.$watch('vehicle.year.value', function(newValue, oldValue){
                                
                                //console.log("Year newValue: ",newValue," oldValue: ",oldValue);                                
                                
                                // if the values are same which means user has not changed the value
                                // Below logic only get execute if user change the value for year
                                if(!newValue || newValue === oldValue){
                                    return;
                                }
                                
                                // If long vin no need to do any action 
                                if ($scope.isLongVIN()){
                                    return;
                                }

                                //Added to handle the case if prefill service is not returning cost
                                if($scope.vehicle.isPrefilledVehicle.value && $scope.vehicle.vin.value && $scope.vehicle.vin.value.length == 17){
                                    if($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == 'auto' &&
                                        ($scope.vehicle.comprehensiveSymbolCd.value == "" || $scope.vehicle.comprehensiveSymbolCd.value == " ")
                                        && ($scope.vehicle.collisionSymbolCd.value == "" || $scope.vehicle.collisionSymbolCd.value == " ")
                                        && ($scope.vehicle.twoDgVSRSymbol.value == "" || $scope.vehicle.twoDgVSRSymbol.value == " ")){
                                        $scope.showCost = true;
                                    } else {
                                        $scope.showCost = false;
                                    }
                                    if($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == 'motorcycle_aaa' &&
                                        ($scope.vehicle.costNew.amount.value == "" || $scope.vehicle.costNew.amount.value == " " || $scope.vehicle.costNew.amount.value == undefined)){
                                        $scope.showCost = true;
                                    } else {
                                        $scope.showCost = false;
                                    }
                                } else if ($scope.vehicle.year){
                                    $scope.showCost = true;
                                }

                                //Fix for Defect DE1073
                                //if ($scope.vehicle.year.value == undefined)
                               // $scope.populateYears();
                                
                                if($scope.vehicle.year.value!=undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" ) {

                                   // $scope.setPurchaseDayVisible();
                                    $scope.populateMake();
                                }else if($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa"){
                                   // $scope.setPurchaseDayVisible();
                                    $scope.populateHldiMake();
                                }
                                if($scope.vehicle.year.value != undefined && $scope.years.length > 0 && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN!=false*/) {

                                    // $scope.setPurchaseDayVisible();
                                    $scope.makesList = [];
                                    $scope.models = [];
                                    $scope.cylinders = [];
                                    $scope.populateMake();
                                }else if($scope.vehicle.year.value != undefined && $scope.years.length > 0 && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/){
                                    // $scope.setPurchaseDayVisible();
                                    $scope.makesList = [];
                                    $scope.series = [];
                                    $scope.models = [];
                                    $scope.populateHldiMake();
                                }
                            });
                        
                            watchMake = $scope.$watch('vehicle.make.value', function(newValue, oldValue){
                                
                                //console.log("Make newValue: ", newValue, " oldValue: ", oldValue);
                                // if the values are same which means user has not changed the value
                                // Below logic only get execute if user change the value for make
                                if (!newValue || newValue === oldValue){
                                    return;
                                }
                                
                                // If long vin no need to do any action 
                                if ($scope.isLongVIN()){
                                    return;
                                }
                                
                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && 
                                $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
                            $scope.populateModels();
                            } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && 
                                $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/){
                                for (let make = 0; make < $scope.makesList.length; make++){
                                    if($scope.makesList[make].makeName == $scope.vehicle.make.value){
                                        $scope.hldiMakeNumber = $scope.makesList[make].makeNumber;
                                    }
                                }
                            $scope.populateHldiSeries();
                            }
                            });
                        
                            watchSeries = $scope.$watch('vehicle.series.value', function(newValue, oldValue){

                                // if the values are same which means user has not changed the value
                                // Below logic only get execute if user change the value for make
                                if (!newValue || newValue === oldValue){
                                    return;
                                }
                                // If long vin no need to do any action
                                if ($scope.isLongVIN()){
                                      return;
                                }

                                if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && 
                                    $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" && 
                                    $scope.vehicle.series.value != undefined /*&& $scope.invalidVIN != false*/){
                                $scope.populateHldiModels();
                                }
                            });
                        
                            watchModel = $scope.$watch('vehicle.model.value', function(newValue, oldValue){
                                
                                //console.log("Model newValue: ", newValue, " oldValue: ", oldValue);
                                // if the values are same which means user has not changed the value
                                // Below logic only get execute if user change the value for model
                                if (!newValue || newValue === oldValue){
                                    return;
                                }
                                
                                // If long vin no need to do any action 
                                if ($scope.isLongVIN()){
                                    return;
                                }
                                
                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && 
                                $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
                                    $scope.populateCylinders();
                                }
                                else if($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && 
                                    $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/){
                                    $scope.populateBikeShortVin();
                                }
                                else if($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.models != undefined && $scope.models.length > 0 && 
                                    $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/){
                                    $scope.populateBikeShortVin();
                                }
                            });
                        
                            watchCylinder = $scope.$watch('vehicle.cylinder.value', function(newValue, oldValue){
                                
                                //console.log("Cylinder newValue: ", newValue, " oldValue: ", oldValue);
                                // if the values are same which means user has not changed the value
                                // Below logic only get execute if user change the value for cylinder
                                if (!newValue || newValue === oldValue){
                                    return;
                                }           
                                
                                // If long vin no need to do any action 
                                if ($scope.isLongVIN()){
                                    return;
                                }
                                
                                if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && 
                                    $scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
                                $scope.populateCarShortVin();
                                }
                            });

                            watchphysicalDamage =  $scope.$watch('vehicle.damageInAccident.value', function(){
                                    if($scope.vehicle.damageInAccident.value){
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                            'quoteandbind.pa.directives.PAEditVehicle.physicalDamage.errorMsg');
                                        }
                            });

                            watchStorageTye =  $scope.$watch('vehicle.storageType.value.code',function(oldValue,newValue){
                                if($scope.vehicle.storageType && $scope.vehicle.storageType.value){
                                    if('driveway' === $scope.vehicle.storageType.value.code || 'onstreet' === $scope.vehicle.storageType.value.code
                                        || 'parkinglot' === $scope.vehicle.storageType.value.code || 'other' === $scope.vehicle.storageType.value.code) {
                                       if ($scope.vehicle.year.value != undefined
                                        && $scope.vehicle.make.value != undefined
                                            && $scope.vehicle.model.value != undefined){
                                    const message = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.StorageTypePhysicalDamage.WithVehicleDetails',{vehicleYear : $scope.vehicle.year.value, vehicleMake :$scope.vehicle.make.value,vehicleModel:$scope.vehicle.model.value})
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                        message);

                                   }else{

                                     ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                        'quoteandbind.pa.directives.PAEditVehicle.StorageTypePhysicalDamage.Msg');

                                   }
                                    }
                               }
                            });



                                $scope.primaryUser = {
                        less10 : "Commute less than 10 miles one way to work",
                        more10 : "Commute more than 10 miles one way work",
                        Personal : "Personal use",
                        Business : "Business (errands, sales calls)"
                    };
                    
                    $scope.ownership ={
                        LOSSP:"Own and Make Payments",
                        additionalinterest_aaa:"Lease",
                        Own:"Own"
                    };
                    
                    $scope.driverType ={
                       principal: "More than 50%",
                       occasional: "Less than 50 %"
                    };
                    
                    $scope.paTypes = {
                        auto: "Vehicle",
                        motorcycle_aaa: "Motorcycle"
                    };
                    
            }    
            

                    $scope.setVehicleType = () => {
                        // ENHC0011961_EODB QnB Defaults- defaulting vehicle --Arpita sengupta
                        $scope.vehicle.paType = $scope.vehicle.tmpPaType.value ?  $scope.vehicle.tmpPaType.value : 'auto';
                        $scope.makesList = undefined;
                        $scope.series = undefined;
                        $scope.models = undefined;
                        $scope.cylinders = undefined;
                        $scope.vehicle.vin.value = undefined;
                        $scope.vehicle.year.value = undefined;
                        $scope.vehicle.make.value = undefined;
                        $scope.vehicle.series.value = undefined;
                        $scope.vehicle.model.value = undefined;
                        $scope.vehicle.cylinder.value = undefined;
                        $scope.vehicle.cCs.value = undefined;
                        $scope.vehicle.bodyType.value = undefined;
                        $scope.vehicle.bodyStyle.value = undefined;
// Reset vehicle modifiers and symbols value
                                $scope.vehicle.vehicleSurchargeCd.value = undefined;
                                $scope.vehicle.comprehensiveSymbolCd.value = undefined;
                                $scope.vehicle.collisionSymbolCd.value = undefined;
                                $scope.vehicle.twoDgVSRSymbol.value = undefined;
                                $scope.vehicle.paAntiLockBrakes.value = undefined;
                                $scope.vehicle.paPassiveRestraint.value = undefined;
                                $scope.vehicle.paAntiTheft.value = undefined;
                                $scope.vehicle.costNew.amount.value = undefined;
                               // $scope.showCost = true;

                        if($scope.years.length == 0){
                            $scope.populateYears();
                        }
                    };
                    
                    //To set the dropdown value of the Usage type
                      $scope.setVehicleUsage = ()=>{
                          if ($scope.vehicle.tmpPrimeUse.value == "less10"){
                            $scope.vehicle.primaryUse.value = "commuting"
                                    $scope.vehicle.commutingMiles.value = 5
                            } else if ($scope.vehicle.tmpPrimeUse.value == "more10"){
                            $scope.vehicle.primaryUse.value = "commuting"
                                    $scope.vehicle.commutingMiles.value = 15
                            } else if ($scope.vehicle.tmpPrimeUse.value == "Personal"){
                                $scope.vehicle.primaryUse.value = "pleasure";
                            } else if ($scope.vehicle.tmpPrimeUse.value == "Business"){
                                $scope.vehicle.primaryUse.value = "business";
                            }
                            else {
                            $scope.vehicle.primaryUse.value = "Commercial"
                            }
                      };
                      
                      //To set ownership
                    $scope.setOwnership = (assignowner) => {
                        $scope.vehicle.tmpOwnership.value = assignowner;
                        if (assignowner == "LOSSP"){
                            $scope.vehicle.ownership = "LOSSP"
                            $scope.vehicle.addnlInterest =  {};
                            $scope.vehicle.addnlInterest.addnlInterestAddress =  {};
                        } else if (assignowner == "additionalinterest_aaa"){
                            $scope.vehicle.ownership = "additionalinterest_aaa"
                            $scope.vehicle.addnlInterest = {};
                            $scope.vehicle.addnlInterest.addnlInterestAddress =  {};
                        } else if (assignowner == "Own") {
                            $scope.vehicle.ownership = undefined;
                            $scope.vehicle.addnlInterest = undefined;
                        }
                    };
                    /*Added for ownership dropdown in mobile view*/
                        $scope.setOwnerShipSelected = function () {
                            var selectedType = $scope.vehicle.tmpOwnership.value;
                            $scope.setOwnership(selectedType)
                        }
                      
/*##################### VIN  Start ############################ */                    
                     $scope.populateMake = ()=> {
                         
                        var     vinDetails = {
                                        vinNumber: undefined,
                                        policyEffectiveDate: undefined,
                                        year: undefined,
                                        make: undefined,
                                        model: undefined,
                                        cylinder: undefined,
                                        restraints: undefined,
                                        shortvin: undefined,
                                        searchType: undefined
                                };
                               // $scope.vinDetails.searchType = "MakesByYear"
                                   vinDetails.searchType = "MakesByYear"
                                   vinDetails.year = $scope.vehicle.year.value
                                   
                                   $scope.setAdditionalRequestParamsAuto(vinDetails);
                                   
                                $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                                        (vehicleInfo)=> {
                                    $scope.makesList = vehicleInfo.makesList || [];
                                    
                                    // When quote retrieved
                                    $timeout(function(){
                                        if ($scope.vehicle.year.value != undefined
                                                && $scope.vehicle.make.value != undefined
                                                    && $scope.vehicle.model.value != undefined
                                                        && $scope.models.length == 0){
                                            $scope.populateModels();
                                        }
                                    }, 100);
                                });
                     };
                     
                     $scope.populateModels = ()=> {
                                                  
                        var        vinDetails = {
                                    vinNumber: undefined,
                                    policyEffectiveDate: undefined,
                                    year: undefined,
                                    make: undefined,
                                    model: undefined,
                                    cylinder: undefined,
                                    restraints: undefined,
                                    shortvin: undefined,
                                    searchType: undefined
                            };
                        vinDetails.searchType = "ModelsByYearAndMake";
                       vinDetails.searchType = "ModelsByYearAndMake";
                        vinDetails.year = $scope.vehicle.year.value;
                        vinDetails.make = $scope.vehicle.make.value;
                        
                        $scope.setAdditionalRequestParamsAuto(vinDetails);
                        
                        $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                        (modelInfo) =>{
                            $scope.modelsList = modelInfo.modelsList || [];
                            $scope.models = [];
                            for (let model = 0; model < $scope.modelsList.length; model++){
                                $scope.models.push($scope.modelsList[model].modelCode);
                            }
                            
                            // When quote retrieved
                            // When quote retrieved
                            $timeout(function(){
                                if ($scope.vehicle.year.value != undefined
                                    && $scope.vehicle.make.value != undefined
                                        && $scope.vehicle.model.value != undefined
                                            && $scope.vehicle.cylinder.value != undefined
                                                && $scope.cylinders.length == 0){
                                $scope.populateCylinders();
                                }
                            }, 100);
                        });
                    };
                    
                    $scope.populateCylinders = () => {
                        var   vinDetails = {
                                    vinNumber: undefined,
                                    policyEffectiveDate: undefined,
                                    year: undefined,
                                    make: undefined,
                                    model: undefined,
                                    cylinder: undefined,
                                    restraints: undefined,
                                    shortvin: undefined,
                                    searchType: undefined
                                };
                            vinDetails.searchType = "AvailableCylindersforaModel";
                            vinDetails.year = $scope.vehicle.year.value;
                            vinDetails.make = $scope.vehicle.make.value;
                            vinDetails.model = $scope.vehicle.model.value;
                            
                            $scope.setAdditionalRequestParamsAuto(vinDetails);
                            
                            $q.when(VinLookupService.aaaVINLookup('quoteandbind',vinDetails),
                                    (cylinderInfo) => {
                            $scope.cylinderList = cylinderInfo.cylindersList || []
                                    //$scope.cylinders.length = 0
                                    $scope.cylinders = [];
                                    for (let cylinder = 0; cylinder < $scope.cylinderList.length; cylinder++){
                            $scope.cylinders.push($scope.cylinderList[cylinder])
                            }
                            });
                    };
                    
                    $scope.populateRestraints = () => {
                        
                        var vinDetails = {
                            searchType  : "Restraints",
                            year        : $scope.vehicle.year.value,
                            make        : $scope.vehicle.make.value,
                            model       : $scope.vehicle.model.value,
                            cylinder    : $scope.vehicle.cylinder.value,
                            vinNumber   : $scope.vehicle.vin.value
                        };
                        
                        $scope.setAdditionalRequestParamsAuto(vinDetails);
                        
                        $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                        (restraintInfo) => {
                            
                            $scope.vehicle.restrInd.value = restraintInfo.restraints;
                            $scope.vehicle.paPassiveRestraint.value = restraintInfo.vehicleData.paPassiveRestraint;
                            $scope.vehicle.bodyType.value = restraintInfo.vehicleData.bodyType;
                            
                            // Populate price new symbol list
                            $scope.populatePriceNewSymbol();
                        },
                        (error) => {
                            console.log(error);
                        });
                    };
                    
                    $scope.populatePriceNewSymbol = () => {

                        var vinDetails = {
                            searchType  : "PriceNewSymbol",
                            year        : $scope.vehicle.year.value,
                            make        : $scope.vehicle.make.value,
                            model       : $scope.vehicle.model.value,
                            cylinder    : $scope.vehicle.cylinder.value,
                            vinNumber   : $scope.vehicle.vin.value
                        };
                                
                        $scope.setAdditionalRequestParamsAuto(vinDetails);
                        
                        $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                        (priceNewSymInfo) => {
                                                        
                            // TODO:: Set cost new or not
                            if(priceNewSymInfo.vehicleData && priceNewSymInfo.vehicleData.costNew)
                            $scope.vehicle.costNew.amount.value = priceNewSymInfo.vehicleData.costNew.amount;
                        },
                        (error) => {
                            console.log(error);
                        });
                    };
                    
                    
                    $scope.populateCarShortVin =()=> {
                        
                        var    vinDetails = {
                                    vinNumber: undefined,
                                    policyEffectiveDate: undefined,
                                    year: undefined,
                                    make: undefined,
                                    model: undefined,
                                    cylinder: undefined,
                                    restraints: undefined,
                                    shortvin: undefined,
                                    searchType: undefined
                            };
                        //$scope.vinDetails.searchType = "AvailableShortVins";
                        vinDetails.searchType = "AvailableShortVins";
                        vinDetails.year = $scope.vehicle.year.value;
                        vinDetails.make = $scope.vehicle.make.value;
                        vinDetails.model = $scope.vehicle.model.value;
                        vinDetails.cylinder = $scope.vehicle.cylinder.value;
                        
                        $scope.setAdditionalRequestParamsAuto(vinDetails);
                        
                        $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
                                (shortVinInfo) => {
                            //Changed for DE752
                            $scope.shortvinsList = shortVinInfo.shortvinsList || [];
                            $scope.vehicle.shortVin = $scope.shortvinsList[0];
                        if ($scope.vehicle.vin.value != undefined && $scope.vehicle.vin.value.length < 17 ){
                            if($scope.vehicle.shortVin.value && $scope.vehicle.shortVin.value.length > 0) {
                                $scope.vehicle.vin.value = $scope.vehicle.shortVin.value;
                                $scope.showCost = false;
                                if (shortVinInfo.vehicleData.comprehensiveSymbolCd){
                                    $scope.vehicle.comprehensiveSymbolCd.value = shortVinInfo.vehicleData.comprehensiveSymbolCd.trim();
                                }

                                if (shortVinInfo.vehicleData.collisionSymbolCd){
                                    $scope.vehicle.collisionSymbolCd.value = shortVinInfo.vehicleData.collisionSymbolCd.trim();
                                }

                                if (shortVinInfo.vehicleData.twoDgVSRSymbol){
                                    $scope.vehicle.twoDgVSRSymbol.value = shortVinInfo.vehicleData.twoDgVSRSymbol.trim();
                                }

                                if (shortVinInfo.vehicleData.vehicleSurchargeCode){
                                    $scope.vehicle.vehicleSurchargeCd.value = shortVinInfo.vehicleData.vehicleSurchargeCode.trim();
                                }
                            }
                        }else{
                            if(typeof $scope.vehicle.vin.value === 'undefined'){
                                $scope.vehicle.vin.value = $scope.vehicle.shortVin.value;
                                $scope.showCost = $scope.vehicle.shortVin && $scope.vehicle.shortVin.value ?false: true;
                                if (shortVinInfo.vehicleData.comprehensiveSymbolCd){
                                    $scope.vehicle.comprehensiveSymbolCd.value = shortVinInfo.vehicleData.comprehensiveSymbolCd.trim();
                                }

                                if (shortVinInfo.vehicleData.collisionSymbolCd){
                                    $scope.vehicle.collisionSymbolCd.value = shortVinInfo.vehicleData.collisionSymbolCd.trim();
                                }

                                if (shortVinInfo.vehicleData.twoDgVSRSymbol){
                                    $scope.vehicle.twoDgVSRSymbol.value = shortVinInfo.vehicleData.twoDgVSRSymbol.trim();
                                }

                                if (shortVinInfo.vehicleData.vehicleSurchargeCode){
                                    $scope.vehicle.vehicleSurchargeCd.value = shortVinInfo.vehicleData.vehicleSurchargeCode.trim();
                                }
                            }
                        }
                        
                            // Populate Restraints
                            $scope.populateRestraints();

                        });
                };              
        
                    
/*##################### VIN  end  ############################ */ 

                        $scope.populateBikeShortVin = () => {
                            var hldiDetails = {
                                            vin: undefined,
                                            ccr: undefined,
                                            modelYear: undefined,
                                            seriesName: undefined,
                                            makeNumber: undefined,
                                            modelName: undefined,
                                            searchType: undefined,
                                            make : undefined,
                                            quoteId: undefined
                                };
                            hldiDetails.searchType = "GetVinPatSpecsList";
                            hldiDetails.CCR = "ZEM2O9S8F9A1";
                            hldiDetails.vin = $scope.vehicle.vin.value;
                            hldiDetails.modelYear = $scope.vehicle.year.value;
                            //hldiDetails.makeNumber = $scope.vehicle.make.value;
                            hldiDetails.makeNumber = $scope.hldiMakeNumber;
                            hldiDetails.modelName = $scope.vehicle.model.value;
                            hldiDetails.makeList = $scope.makesList;
                            hldiDetails.make = $scope.vehicle.make.value;
                            hldiDetails.seriesName = $scope.vehicle.series.value;
                            hldiDetails.quoteId = $scope.quoteId.value;
                            
                            $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails),
                                    (shortVinInfo) => {
                                //Changed for DE752
                            if ($scope.vehicle.vin.value != undefined && $scope.vehicle.vin.value.length < 17 ){
                                if(shortVinInfo.shortVinList && shortVinInfo.shortVinList.length > 0 && shortVinInfo.shortVinList[0].vinPat){
                                    $scope.vehicle.vin.value = shortVinInfo.shortVinList[0].vinPat.trim();
                                    // Set body style - INC0001398 
                                    $scope.vehicle.bodyStyle.value = shortVinInfo.shortVinList[0].vehicleClassDesc.trim();
                                    $scope.vehicle.cCs.value = shortVinInfo.shortVinList[0].displacement.trim();
                                    if(shortVinInfo.shortVinList[0].basePrice != undefined){
                                        $scope.vehicle.costNew.amount.value = shortVinInfo.shortVinList[0].basePrice.trim();
                                    }

                                }
                            }else{
                                if(typeof $scope.vehicle.vin.value === 'undefined'){
                                    if(shortVinInfo.shortVinList && shortVinInfo.shortVinList.length > 0 && shortVinInfo.shortVinList[0].vinPat){
                                        $scope.vehicle.vin.value = shortVinInfo.shortVinList[0].vinPat.trim();
                                        // Set body style - INC0001398
                                        $scope.vehicle.bodyStyle.value = shortVinInfo.shortVinList[0].vehicleClassDesc.trim();
                                        $scope.vehicle.cCs.value = shortVinInfo.shortVinList[0].displacement.trim();
                                        if(shortVinInfo.shortVinList[0].basePrice != undefined){
                                            $scope.vehicle.costNew.amount.value = shortVinInfo.shortVinList[0].basePrice.trim();
                                        }
                                    }
                                }
                            }
                        });
                        };
/**************************    HLDI     ****************************/
                        $scope.populateHldiModels = () => {
                            var hldiDetails = {
                                    vin: undefined,
                                    ccr: undefined,
                                    modelYear: undefined,
                                    seriesName: undefined,
                                    makeNumber: undefined,
                                    modelName: undefined,
                                    searchType: undefined,
                                    quoteId: undefined
                                };
                           
                            hldiDetails.CCR = "ZEM2O9S8F9A1"
                            hldiDetails.searchType = "GetModelList";
                            hldiDetails.modelYear = $scope.vehicle.year.value;
                            //hldiDetails.makeNumber = $scope.vehicle.make.value;
                           hldiDetails.make = $scope.vehicle.make.value;
                           hldiDetails.makeNumber = $scope.hldiMakeNumber;
                           hldiDetails.makeList = $scope.makesList;
                           hldiDetails.seriesName = $scope.vehicle.series.value;
                           hldiDetails.quoteId = $scope.quoteId.value;
                            $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails),
                                    (modelInfo) => {
                                    $scope.modelsList = modelInfo.modelNameList || [];
                                    //$scope.models.length = 0
                                    $scope.models = [];
                                    for (let model = 0; model < $scope.modelsList.length; model++){
                                        $scope.models.push($scope.modelsList[model])
                                    }
                            });
                        };
                
                        $scope.populateHldiMake = () => {
                            var hldiDetails = {
                                vin: undefined,
                                ccr: undefined,
                                modelYear: undefined,
                                seriesName: undefined,
                                makeNumber: undefined,
                                modelName: undefined,
                                searchType: undefined,
                                quoteId: undefined
                            };
                            
                            hldiDetails.searchType = "GetMakeList"
                            hldiDetails.CCR = "ZEM2O9S8F9A1"
                            hldiDetails.modelYear = $scope.vehicle.year.value;
                            hldiDetails.quoteId = $scope.quoteId.value;
                                $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails),
                                        (makeInfo)=> {
                                $scope.makesList = makeInfo.makeList
                                //Commented for DE807 : Start
                                        /*$scope.makes.length = 0
                                        for (let make = 0; make < $scope.makesList.length; make++){
                                $scope.makes.push($scope.makesList[make].makeName)
                                }
                                console.log("HLDI Makes 1 = ", $scope.makes);
                                        console.log("HLDI Makes 2 = ", $scope.makesList);*/
                                //Commented for DE807 : End
                                                                // When quote retrieved
                                                                $timeout(function(){
                                                                    if ($scope.vehicle.year.value != undefined
                                                                            && $scope.vehicle.make.value != undefined
                                                                                && $scope.vehicle.series.value != undefined ){
                                                                        $scope.populateHldiSeries();
                                                                    }
                                                                },100);
                                });
                        };
                    
                        $scope.populateHldiSeries = () => {
                             var hldiDetails = {
                                    vin: undefined,
                                    ccr: undefined,
                                    modelYear: undefined,
                                    seriesName: undefined,
                                    makeNumber: undefined,
                                    modelName: undefined,
                                    searchType: undefined,
                                    quoteId: undefined,
                                    makeList: undefined
                            };
                            
                            hldiDetails.searchType = "GetSeriesList"
                            hldiDetails.CCR = "ZEM2O9S8F9A1"
                            hldiDetails.modelYear = $scope.vehicle.year.value;
                            //hldiDetails.makeNumber = $scope.vehicle.make.value;
                            hldiDetails.make = $scope.vehicle.make.value;
                            hldiDetails.makeNumber = $scope.hldiMakeNumber;
                            hldiDetails.makeList = $scope.makesList;
                            hldiDetails.quoteId = $scope.quoteId.value;
                            $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails),
                                    (seriesInfo)=> {
                            $scope.seriesList = seriesInfo.seriesNameList || [];
                            $scope.series = [];
                            for (let serieal = 0; serieal < $scope.seriesList.length; serieal++){
                            $scope.series.push($scope.seriesList[serieal])
                            }
                            // When quote retrieved


                            $timeout(function(){
                            		 if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined
                                                && $scope.vehicle.series.value != undefined ){
                                                 $scope.populateHldiModels();
                                        }
                                },100);

                            });
                        };




                        $scope.populateDriverName=(person)=>{
                            if(person!=undefined)
                             return   person.firstName+ " "+ person.lastName
                        }
                        
                        // Set additional request params for VIN service new implementation
                        $scope.setAdditionalRequestParamsAuto = (vinDetails) => {
                            
                            vinDetails.vinServiceSearchType = angular.copy(vinDetails.searchType);
                            vinDetails.quoteID = $scope.quoteId.value;
                            
                            if($scope.vehicle && $scope.vehicle.publicID){
                                vinDetails.vehiclePublicId = $scope.vehicle.publicID.value;  
                            }
                            
                            if ($scope.vehicle && $scope.vehicle.tmpPaType){
                                vinDetails.vehicleType = $scope.vehicle.tmpPaType.value;
                            }                                                  
                            
                            vinDetails.masterMakeList = {};
                            var makeList = angular.copy($scope.makesList);
                            
                            // Populating master make list which will be used to create 
                            // a mastermake list in VehicleUIHelper instance
                            if(makeList && makeList.length > 0){                                
                                
                                //console.log("makeList: ", makeList);
                                
                                //make => {makeCode: "ACUR", makeValue: "ACURA"}
                                for(var idx in makeList){
                                    var make = makeList[idx];
                                    vinDetails.masterMakeList[make.makeCode] = make.makeValue;
                                    if ($scope.vehicle.make.value && $scope.vehicle.make.value == make.makeCode){
                                        vinDetails.makeValue = make.makeValue;
                                    }
                                }
                            }
                            
                            // Set restraint value for price new symbol list service call
                            if($scope.vehicle.restrInd != null || $scope.vehicle.restrInd != undefined){
                                vinDetails.restraints = $scope.vehicle.restrInd.value;
                            }
                            
                        };
                        
                        $scope.lookupVehicleVin = () => {
                            
                            var vinDetails = {
                                        vinNumber: undefined,
                                        policyEffectiveDate: undefined,
                                        year: undefined,
                                        make: undefined,
                                        model: undefined,
                                        cylinder: undefined,
                                        restraints: undefined,
                                        shortvin: undefined,
                                        searchType: undefined
                                };
                            if (VinLookupEnabled) {
                            //$scope.invalidVIN = null;
                            $scope.readonly = true;
                                    $scope.showLoading = true;
                                    //$scope.vinDetails.vinNumber = $scope.vehicle.vin.value
                                    //$scope.vinDetails.policyEffectiveDate = $scope.today

                                    //$scope.vinDetails.searchType = "DecodeVinByDate"
                                    vinDetails.vinNumber = $scope.vehicle.vin.value;
                                    vinDetails.policyEffectiveDate = $scope.today
                                    vinDetails.searchType = "DecodeVinByDate"
                                    
                                    // Set additional request params required to call new vin service
                                    $scope.setAdditionalRequestParamsAuto(vinDetails);
                                    
                                    $q.when(VinLookupService.aaaVINLookup('quoteandbind',vinDetails),
                                            (vehicleInfo) => {
                                    if (vehicleInfo && vehicleInfo.vehicleData.make && vehicleInfo.vehicleData.fullModelName && vehicleInfo.vehicleData.isoYear) {
                                   //Autofill with the returned data
                                    //$scope.invalidVIN = false;
                                        //security vulnerabilities --Arpita
                                            let yearCylVal = /^[0-9]+$/
                                            if(!vehicleInfo.vehicleData.isoYear.trim().match(yearCylVal)){
                                                throw new Error(`Please input numeric characters only`);
                                            }else if(!vehicleInfo.vehicleData.engineCyl.trim().match(yearCylVal)) {                                                $scope.vehicle.cylinder.value = ""
                                                throw new Error(`Please input numeric characters only`);
                                            }
                                            //ended 
                                            $scope.vehicle.make.value = vehicleInfo.vehicleData.make.trim();
                                            $scope.vehicle.model.value = vehicleInfo.vehicleData.fullModelName.trim();
                                            $scope.vehicle.year.value = vehicleInfo.vehicleData.isoYear.trim();
                                            $scope.vehicle.cylinder.value = vehicleInfo.vehicleData.engineCyl.trim();
                                            $scope.vinYear = vehicleInfo.vehicleData.isoYear.trim();
                                            $scope.vehicle.paType.value = "auto";
                                            $scope.vehicle.bodyStyle =  vehicleInfo.vehicleData.bodyStyle.trim();
                                            $scope.vehicle.vehicleSurchargeCd.value = vehicleInfo.vehicleData.vehicleSurchargeCode.trim();
                                            $scope.errorMsg = '';
                                            $scope.vehicle.comprehensiveSymbolCd.value = vehicleInfo.vehicleData.comprehensiveSymbolCd.trim();
                                            $scope.vehicle.collisionSymbolCd.value = vehicleInfo.vehicleData.collisionSymbolCd.trim();
                                            if (vehicleInfo.vehicleData.twoDgVSRSymbol){
                                            $scope.vehicle.twoDgVSRSymbol.value = vehicleInfo.vehicleData.twoDgVSRSymbol.trim();
                                            }
                                            // Portal Integration New Fields
                                            $scope.vehicle.bodyType.value = vehicleInfo.vehicleData.bodyType;
                                            $scope.vehicle.paAntiLockBrakes.value = vehicleInfo.vehicleData.paAntiLockBrakes;
                                            $scope.vehicle.paPassiveRestraint.value = vehicleInfo.vehicleData.paPassiveRestraint;
                                            $scope.vehicle.paAntiTheft.value = vehicleInfo.vehicleData.paAntiTheft;
                                            
                                            if(vehicleInfo.vehicleData.comprehensiveSymbolCd.trim() == ""
                                                && vehicleInfo.vehicleData.collisionSymbolCd.trim() == ""
                                                && vehicleInfo.vehicleData.twoDgVSRSymbol.trim() == ""){
                                                $scope.showCost = true;
                                            }
                                            else{
                                                $scope.showCost = false;
                                            }
                                             if(vehicleInfo.vehicleData.abs != null && vehicleInfo.vehicleData.abs != undefined){
                                             $scope.vehicle.abs.value = vehicleInfo.vehicleData.abs.trim();
                                            }
                                            if(vehicleInfo.vehicleData.antiTheft != null && vehicleInfo.vehicleData.antiTheft != undefined){
                                             $scope.vehicle.antiTheft.value = vehicleInfo.vehicleData.antiTheft.trim();
                                            }
                                            if(vehicleInfo.vehicleData.restrInd != null && vehicleInfo.vehicleData.restrInd != undefined){
                                             $scope.vehicle.restrInd.value = vehicleInfo.vehicleData.restrInd.trim();
                                            }
                                            
                                            // Set cost new if long vin returns cost new
                                            if (vehicleInfo.vehicleData.costNew && vehicleInfo.vehicleData.costNew.amount){
                                                $scope.vehicle.costNew.amount.value = vehicleInfo.vehicleData.costNew.amount;
                                            } 
                                            
                                    }else{
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                        'quoteandbind.pa.controller.integration.vinvalidation.info');
                                    $scope.readonly = false;
                                    $scope.showLoading = false;
                                    $scope.makesList = undefined;
                                    $scope.models = undefined;
                                    $scope.cylinders = undefined;
                                    $scope.vehicle.vin.value = undefined;
                                    $scope.vehicle.year.value = undefined;
                                    $scope.vehicle.make.value = undefined;
                                    $scope.vehicle.model.value = undefined;
                                    $scope.vehicle.cylinder.value = undefined;
                                    $scope.vehicle.cCs.value = undefined;
                                    $scope.vehicle.comprehensiveSymbolCd.value = undefined;
                                    $scope.vehicle.collisionSymbolCd.value = undefined;
                                    $scope.vehicle.twoDgVSRSymbol.value = undefined;
                                    $scope.vehicle.bodyStyle.value = undefined;
                                    $scope.vehicle.bodyType.value = undefined;
                                    $scope.showCost = true;
                                    $scope.populateYears();
                                    }
                                    $scope.showLoading = false;
                                    },
                                            () => {
                                    //Something has gone legitimately wrong, let the user input the data manually
                                    //$scope.errorMsg = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.errorMsg'); // POR-2061
                                            $scope.showCost = true;
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                'quoteandbind.pa.controller.integration.vinvalidation.info');
                                            $scope.readonly = false;
                                            $scope.showLoading = false;
                                            $scope.makesList = undefined;
                                            $scope.models = undefined;
                                            $scope.cylinders = undefined;
                                            $scope.vehicle.vin.value = undefined;
                                            $scope.vehicle.year.value = undefined;
                                            $scope.vehicle.make.value = undefined;
                                            $scope.vehicle.model.value = undefined;
                                            $scope.vehicle.cylinder.value = undefined;
                                            $scope.vehicle.cCs.value = undefined;
                                            $scope.vehicle.bodyStyle.value = undefined;
                                            $scope.vehicle.bodyType.value = undefined;
                                            $scope.vehicle.comprehensiveSymbolCd.value = undefined;
                                            $scope.vehicle.collisionSymbolCd.value = undefined;
                                            $scope.vehicle.twoDgVSRSymbol.value = undefined;
                                            $scope.populateYears();
                                    });

                            }
                        };
                        $scope.checkVIN = ()=>{
                            if($scope.vehicle.vin.value.length == 0){
                                $scope.vehicle.year.value = undefined;
                                $scope.vehicle.make.value = undefined;
                                $scope.vehicle.series.value = undefined;
                                $scope.vehicle.model.value = undefined;
                                $scope.vehicle.cylinder.value = undefined;
                                $scope.vehicle.cCs.value = undefined;
                                //$scope.showCost = true;
                                //$scope.populateYears();
                                
                                // Reset vehicle modifiers and symbols value
                                $scope.vehicle.vehicleSurchargeCd.value = undefined;
                                $scope.vehicle.comprehensiveSymbolCd.value = undefined;
                                $scope.vehicle.collisionSymbolCd.value = undefined;
                                $scope.vehicle.twoDgVSRSymbol.value = undefined;
                                $scope.vehicle.bodyType.value = undefined;
                                $scope.vehicle.paAntiLockBrakes.value = undefined;
                                $scope.vehicle.paPassiveRestraint.value = undefined;
                                $scope.vehicle.paAntiTheft.value = undefined;
                                $scope.vehicle.costNew.amount.value = undefined;
                                $scope.vehicle.bodyStyle.value = undefined;
                            }
                            // ENHC0011961_EODB QnB Defaults- populating drivers --Arpita sengupta
                            $scope.vehicle.paType = $scope.vehicle.tmpPaType.value ?  $scope.vehicle.tmpPaType.value : 'auto';
                            //ended
                        };
                        
                        $scope.lookupVin = ()=> {
                            //Added If condition to fix Defect 862
                            if($scope.vehicle.vin.value==undefined){
                                $scope.makesList = undefined;
                                $scope.series = undefined;
                                $scope.models = undefined;
                                $scope.cylinders = undefined;
                                //$scope.vehicle.vin.value = undefined;
                                $scope.vehicle.year.value = undefined;
                                $scope.vehicle.make.value = undefined;
                                $scope.vehicle.series.value = undefined;
                                $scope.vehicle.model.value = undefined;
                                $scope.vehicle.cylinder.value = undefined;
                                $scope.vehicle.cCs.value = undefined;
                                $scope.vehicle.bodyStyle.value = undefined;
                                $scope.vehicle.bodyType.value = undefined;
                                $scope.vehicle.costNew.amount = undefined;
                               // $scope.showCost = true;
                                //$scope.populateYears();
                                if($scope.years.length == 0){
                                    $scope.populateYears();
                                }

                            }
                            else if($scope.vehicle.vin.value) {
                                if ($scope.vehicle.vin.value.length > 0 && $scope.vehicle.vin.value.length < 17) {
                                    ModalService.showInfo('quoteandbind.controllers.ModalService.Attention',
                                        'quoteandbind.pa.directives.PAEditVehicle.checkVin.errorMsg').result;
                                    $scope.makesList = undefined;
                                    $scope.series = undefined;
                                    $scope.models = undefined;
                                    $scope.cylinders = undefined;
                                    $scope.vehicle.vin.value = "";
                                    $scope.vehicle.year.value = undefined;
                                    $scope.vehicle.make.value = undefined;
                                    $scope.vehicle.series.value = undefined;
                                    $scope.vehicle.model.value = undefined;
                                    $scope.vehicle.cylinder.value = undefined;
                                    $scope.vehicle.cCs.value = undefined;
                                    $scope.vehicle.bodyStyle.value = undefined;
                                    $scope.vehicle.bodyType.value = undefined;
                                    $scope.vehicle.costNew.amount = undefined;
                                    //$scope.showCost = true;
                                    $scope.populateYears();
                                }
                                else {
                                    if ($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" && $scope.vehicle.vin.value.length == 17) {
                                        $scope.lookupBikeVin();
                                    }
                                    else if ($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "auto" && $scope.vehicle.vin.value.length == 17) {
                                        $scope.lookupVehicleVin();
                                    }
                                }
                            }
                            // ENHC0011961_EODB QnB Defaults- populating drivers --Arpita sengupta
                            if($scope.drivers.length>=$scope.$parent.vehicles.length){
                                $scope.vehicle.chosenDriver.value = $scope.drivers[$scope.$parent.vehicles.length-1];
                            }
                            else if($scope.drivers.length<$scope.$parent.vehicles.length){
                                $scope.vehicle.chosenDriver.value = $scope.drivers[$scope.$parent.vehicles.length-1] ? $scope.drivers[$scope.$parent.vehicles.length-1] : $scope.drivers[0];
                            }
                            //ended
                        };
                        
                        $scope.lookupBikeVin = ()=>{
                            
                                var hldiDetails = {
                                            vin: undefined,
                                            ccr: undefined,
                                            modelYear: undefined,
                                            seriesName: undefined,
                                            makeNumber: undefined,
                                            modelName: undefined,
                                            searchType: undefined,
                                            quoteId: undefined
                                };
                            //The Bike VIN does not return a match, VIN is invalid
                            
                            hldiDetails.searchType = "Vindicate";
                            hldiDetails.CCR = "ZEM2O9S8F9A1";
                            hldiDetails.vin = $scope.vehicle.vin.value;
                            hldiDetails.quoteId = $scope.quoteId.value;
                             $scope.showLoading = true;
                                $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails),
                                    (bikeInfo) => {
                                if (bikeInfo && bikeInfo.vindicatorData.makeName && bikeInfo.vindicatorData.modelName && bikeInfo.vindicatorData.modelYear){
                                    //$scope.invalidVIN = false;
                                    $scope.vehicle.make.value = bikeInfo.vindicatorData.makeName;
                                    $scope.vehicle.model.value = bikeInfo.vindicatorData.modelName;
                                    $scope.vehicle.year.value = bikeInfo.vindicatorData.modelYear.trim();
                                    $scope.vehicle.cCs.value = bikeInfo.vindicatorData.displacement.trim();
                                    $scope.vehicle.bodyStyle.value = bikeInfo.vindicatorData.vehicleClassDesc.trim();
                                    $scope.vehicle.bodyType.value = bikeInfo.vindicatorData.bodyType;
                                    
                                    $scope.vehicle.paType.value = "motorcycle_aaa"
                                    $scope.errorMsg = '';
                                    $scope.showLoading = false;
                                    $scope.vehicle.series.value = bikeInfo.vindicatorData.seriesName.trim();
                                    if(bikeInfo.vindicatorData.basePrice.trim() == "" || bikeInfo.vindicatorData.basePrice == undefined ){
                                        //$scope.vehicle.costNew.amount = 1;
                                        $scope.showCost = true;
                                    } else {
                                        $scope.vehicle.costNew.amount = bikeInfo.vindicatorData.basePrice.trim();
                                        $scope.showCost = false;
                                    }

                                }else{
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                        'quoteandbind.pa.controller.integration.vinvalidation.info');
                                    $scope.readonly = false;
                                    $scope.showLoading = false;
                                    //$scope.invalidVIN = true;
                                    //Need to check use of the below statement
                                    //$scope.vehicle.year.value = undefined;
                                    $scope.makesList = undefined;
                                    $scope.models = undefined;
                                    $scope.cylinders = undefined;
                                    $scope.vehicle.vin.value = undefined;
                                    $scope.vehicle.year.value = undefined;
                                    $scope.vehicle.make.value = undefined;
                                    $scope.vehicle.model.value = undefined;
                                    $scope.vehicle.cylinder.value = undefined;
                                    $scope.vehicle.cCs.value = undefined;
                                    $scope.vehicle.bodyStyle.value = undefined;
                                    $scope.vehicle.bodyType.value = undefined;
                                    $scope.vehicle.series.value = undefined;
                                    $scope.vehicle.costNew.amount = undefined;
                                    $scope.showCost = true;
                                    $scope.populateYears();
                                }
                                $scope.showLoading = false;
                            },()=>{
                                    $scope.showCost = true;
                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                                        'quoteandbind.pa.controller.integration.vinvalidation.info');
                                    $scope.readonly = false;
                                    $scope.showLoading = false;
                                    //$scope.invalidVIN = true;
                                    $scope.errorMsg = '';

                                    $scope.makesList = undefined;
                                    $scope.series = undefined;
                                    $scope.models = undefined;
                                    $scope.vehicle.vin.value = undefined;
                                    $scope.vehicle.year.value = undefined;
                                    $scope.vehicle.make.value = undefined;
                                    $scope.vehicle.series.value = undefined;
                                    $scope.vehicle.model.value = undefined;
                                    $scope.vehicle.cCs.value = undefined;
                                    $scope.vehicle.bodyStyle.value = undefined;
                                    $scope.vehicle.bodyType.value = undefined;
                                    $scope.vehicle.costNew.amount = undefined;
                                    $scope.populateYears();
                                });
                        };

                        $scope.generateShortVIN = ()=> {
                            if ($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa")
                            { $scope.populateBikeShortVin();
                            } else if($scope.vehicle.paType.value!= undefined && $scope.vehicle.paType.value.code == "auto"){
                              $scope.populateCarShortVin();
                            }
                        };

                        resetForm();
                        $scope.$on('update-form', ()=> {
                            
                            resetForm();
                            $scope.isFormSubmitted = true;
                            /*if ($scope.vehicle!= undefined 
                                    && $scope.vehicle.year!=undefined 
                                        && $scope.vehicle.year.value == undefined){
                                $scope.populateYears();   
                             }*/
                            //$scope.populateYears(); 
                            
                            watchYear();
                            watchMake();
                            watchCylinder();
                            watchModel();
                            watchphysicalDamage();
                            watchStorageTye();
                            //resetForm();
                            
                        });
                        $scope.$on('submit-form', ()=> {
                            $scope.isFormSubmitted = true;
                        });
                    }]
                };
            }];
    });


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/directives/PAEditVehicle.js
 **/